import { type BaseMovementRepository } from "../../_Bases/BaseMovementRepository";
import { type LocalDatabaseMovement } from "../../_Bases/BaseMovementRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBMovementRepository extends BaseIndexedDBRepository<
    LocalDatabaseMovement
> implements BaseMovementRepository {
    public readonly source: InternalIndexedDBDatabase["movements"];
    protected readonly dataTypeName = "Movement";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.movements;
    }
}
